const team = [
  {
    name: 'SHAY Team',
    role: 'Worship, Skits & Creative Ministry',
    tag: 'Host Team',
    desc: 'SHAY brings worship, skits, and creative ministry with a burning burden for the next generation — a team on fire, surrendered to God, and passionate about revival.',
    img: 'https://static.readdy.ai/image/d9bb5601c98f22586a2b11870925187d/de4eeff5d8653ad32c01277d3b5372f4.jpeg',
    fit: 'cover' as const,
    position: 'center 30%',
  },
  {
    name: 'Ameeth Evans',
    role: 'Worship & The Word',
    tag: 'Minister',
    desc: 'Ministering in worship and the Word with a heart for revival, the presence of God, and the reclaiming of this generation for Jesus Christ.',
    img: 'https://public.readdy.ai/ai/img_res/edited_1123ed372aab692d0ddf2d64b011c960_fc16f9c0.jpg',
    fit: 'cover' as const,
    position: 'center top',
  },
];

const MinistryTeam = () => {
  return (
    <section
      id="ministry-team"
      className="relative py-20 px-4 sm:px-6 lg:px-12 overflow-hidden"
      style={{ background: 'linear-gradient(180deg, #090909 0%, #060606 100%)' }}
    >
      {/* Top divider */}
      <div
        className="absolute top-0 left-0 right-0 h-px pointer-events-none"
        style={{ background: 'linear-gradient(90deg, transparent, rgba(212,168,66,0.5), transparent)' }}
      />

      {/* Centre ambient glow */}
      <div
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none"
        style={{
          width: '900px',
          height: '600px',
          background: 'radial-gradient(ellipse, rgba(212,168,66,0.05) 0%, transparent 65%)',
        }}
      />

      <div className="max-w-6xl mx-auto relative z-10">
        {/* Header */}
        <div className="text-center mb-14">
          <div
            className="inline-flex items-center gap-2 mb-6 px-5 py-1.5 rounded-full text-xs font-bold tracking-widest uppercase"
            style={{
              background: 'rgba(212,168,66,0.1)',
              border: '1px solid rgba(212,168,66,0.35)',
              color: '#D4A842',
              fontFamily: "'Glacial Indifference', sans-serif",
            }}
          >
            <span>✦</span> The Ministers
          </div>
          <h2
            className="font-black uppercase mb-3"
            style={{
              fontFamily: "'Glacial Indifference', sans-serif",
              fontSize: 'clamp(2rem, 5vw, 3.2rem)',
              color: '#FFFFFF',
              textShadow: '0 0 40px rgba(212,168,66,0.25)',
            }}
          >
            Ministry Team
          </h2>
          <p
            className="text-sm max-w-md mx-auto leading-relaxed"
            style={{ color: '#777', fontFamily: "'Glacial Indifference', sans-serif" }}
          >
            Vessels surrendered to God, carrying the fire of revival for this generation.
          </p>
        </div>

        {/* Cards grid */}
        <div className="flex flex-wrap justify-center gap-6">
          {team.map((member, idx) => (
            <div
              key={member.name}
              className="group relative rounded-2xl overflow-hidden transition-all duration-300 hover:scale-[1.02] cursor-default flex flex-col"
              style={{
                border: '1px solid rgba(212,168,66,0.22)',
                background: '#0c0c0c',
                width: '100%',
                maxWidth: '380px',
              }}
            >
              {/* ── Image area ── */}
              <div
                className="relative w-full overflow-hidden flex-shrink-0"
                style={{ height: '300px', background: '#0a0a0a' }}
              >
                <img
                  src={member.img}
                  alt={member.name}
                  className="w-full h-full transition-transform duration-700 group-hover:scale-105"
                  style={{
                    objectFit: member.fit,
                    objectPosition: member.position,
                    display: 'block',
                  }}
                />

                <div
                  className="absolute bottom-0 left-0 right-0 pointer-events-none"
                  style={{
                    height: '60px',
                    background: 'linear-gradient(to bottom, rgba(12,12,12,0) 0%, rgba(12,12,12,0.85) 100%)',
                  }}
                />

                {/* Stage spotlight beam */}
                <div
                  className="absolute top-0 left-1/2 -translate-x-1/2 pointer-events-none"
                  style={{
                    width: '2px',
                    height: '50%',
                    background: 'linear-gradient(to bottom, rgba(212,168,66,0.4) 0%, transparent 100%)',
                  }}
                />

                {/* Tag badge */}
                <div className="absolute top-4 left-4">
                  <div
                    className="px-3 py-1 rounded-full text-xs font-bold tracking-widest uppercase whitespace-nowrap"
                    style={{
                      background: 'rgba(0,0,0,0.55)',
                      border: '1px solid rgba(212,168,66,0.45)',
                      color: '#D4A842',
                      fontFamily: "'Glacial Indifference', sans-serif",
                      backdropFilter: 'blur(10px)',
                    }}
                  >
                    {member.tag}
                  </div>
                </div>

                {/* Number watermark */}
                <div
                  className="absolute right-3 bottom-2 font-black select-none pointer-events-none"
                  style={{
                    fontFamily: "'Blinker', sans-serif",
                    fontSize: '4.5rem',
                    color: 'rgba(212,168,66,0.07)',
                    lineHeight: 1,
                  }}
                >
                  0{idx + 1}
                </div>
              </div>

              {/* ── Content ── */}
              <div className="p-6 flex flex-col flex-1">
                <h3
                  className="font-black mb-1"
                  style={{
                    fontFamily: "'Glacial Indifference', sans-serif",
                    fontSize: 'clamp(1.1rem, 3vw, 1.35rem)',
                    color: '#FFFFFF',
                  }}
                >
                  {member.name}
                </h3>
                <p
                  className="text-xs font-semibold mb-4 tracking-wide"
                  style={{ color: '#D4A842', fontFamily: "'Glacial Indifference', sans-serif" }}
                >
                  {member.role}
                </p>
                <div
                  className="h-px w-10 mb-4"
                  style={{ background: 'linear-gradient(to right, rgba(212,168,66,0.55), transparent)' }}
                />
                <p
                  className="text-sm leading-relaxed flex-1"
                  style={{ color: '#999', fontFamily: "'Glacial Indifference', sans-serif" }}
                >
                  {member.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MinistryTeam;
